/* =========================================================
   HERMES Yacht-Master v5 — Multi-template animations
   Combines: Preloader counter · BlurText word-by-word ·
   Scoped cursor trail · Letter-by-letter reveal ·
   Horizontal scroll-scrub · Slot-machine counter ·
   Spotlight mouse reveal · Rotating words
   ========================================================= */

(function () {
  function initAntiSpy(root) {
    if (!root.classList.contains('hm5-yacht--anti-spy')) return;
    const overlay = document.getElementById('hm5-caught');
    if (!overlay) return;

    let caught = false;
    function show(reason) {
      if (caught) return;
      caught = true;
      overlay.classList.add('hm5-caught--active');
      try { console.clear(); } catch(_) {}
      try { window.history.replaceState({}, '', window.location.pathname); } catch(_) {}
    }

    // 1) Right-click
    document.addEventListener('contextmenu', (e) => { e.preventDefault(); show('rclick'); });
    // 2) Drag de imagenes/video
    document.addEventListener('dragstart', (e) => {
      const t = e.target;
      if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO' || t.tagName === 'PICTURE')) {
        e.preventDefault();
        show('drag');
      }
    });
    // 3) Keyboard shortcuts comunes para inspect/save/view-source
    document.addEventListener('keydown', (e) => {
      const cmb = e.ctrlKey || e.metaKey;
      const key = (e.key || '').toLowerCase();
      if (
        e.key === 'F12' ||
        (cmb && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) ||
        (cmb && (key === 'u' || key === 's' || key === 'p'))
      ) {
        e.preventDefault();
        show('shortcut');
      }
    });
    // 4) DevTools detection (timing-based via debugger + window size delta)
    function detectDevTools() {
      const threshold = 160;
      const widthGap = window.outerWidth - window.innerWidth;
      const heightGap = window.outerHeight - window.innerHeight;
      if (widthGap > threshold || heightGap > threshold) {
        show('devtools');
      }
    }
    setInterval(detectDevTools, 1500);
    window.addEventListener('resize', detectDevTools, { passive: true });

    // 5) Anti console-debugger trick: timing diff if DevTools is open
    setInterval(() => {
      const t0 = performance.now();
      // eslint-disable-next-line no-debugger
      // The debugger statement only pauses if DevTools is open. If pause > 100ms, caught.
      try { debugger; } catch(_) {}
      const t1 = performance.now();
      if (t1 - t0 > 100) show('debugger-pause');
    }, 4000);
  }

  /* ─── Releasit COD integration ─────────────────────────────
     Cuando el usuario clickea CUALQUIER CTA (hero, etc), proxeamos al boton principal
     que Releasit ha convertido en su _rsi-buy-now-button.
     IMPORTANT: NO scrollear como fallback — si Releasit no esta listo, esperar
     hasta que lo este (hasta 5s) y luego ejecutar el click. */
  function initReleasitIntegration(root) {
    const proxyCTAs = root.querySelectorAll('.hm5-hero__cta');

    function findRsiButton() {
      // Multiple selectores donde Releasit puede haber puesto el boton trigger
      return document.querySelector('._rsi-buy-now-button:not([data-hm5-handled])')
          || document.querySelector('#_rsi-buy-now-button-overwrite')
          || document.querySelector('[data-hm5-main-cta]');
    }

    function tryClick(btn, attempt) {
      attempt = attempt || 0;
      const rsiBtn = findRsiButton();
      if (rsiBtn) {
        console.info('[HERMES] Disparando Releasit modal via', rsiBtn.className || rsiBtn.id);
        // Click programatico para abrir modal
        rsiBtn.click();
        return true;
      }
      if (attempt < 10) {  // max 5s de espera (10 * 500ms)
        setTimeout(() => tryClick(btn, attempt + 1), 500);
      } else {
        console.warn('[HERMES] Releasit no detectado — verifica config dashboard');
      }
      return false;
    }

    proxyCTAs.forEach(cta => {
      cta.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        tryClick(cta);
      });
    });

    // Mark Releasit button as handled when it appears (para diagnostico)
    if ('MutationObserver' in window) {
      const obs = new MutationObserver(() => {
        const rsiBtn = document.querySelector('._rsi-buy-now-button:not([data-hm5-handled])');
        if (rsiBtn) {
          rsiBtn.setAttribute('data-hm5-handled', '1');
          console.info('[HERMES] Releasit button detectado:', rsiBtn.className);
          obs.disconnect();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 15000);
    }
  }

  /* ─── Variant selector handling ─────────────────────────────
     Si el producto tiene multiples variantes, los botones de variant selector
     deben actualizar:
     1. El variant_id en el hidden input del form (para que Releasit/Shopify use la variante correcta)
     2. El precio en el hero (price card) y en el final CTA
     3. La data global window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS (para Releasit) */
  function initVariantSelector(root) {
    const wrap = root.querySelector('[data-hm5-variants]');
    if (!wrap) return;
    const jsonEl = wrap.querySelector('[data-hm5-variants-json]');
    if (!jsonEl) return;

    let variants;
    try { variants = JSON.parse(jsonEl.textContent.trim()); } catch(e) { return; }
    if (!variants || !variants.length) return;

    const variantInput = root.querySelector('[data-hm5-variant-input]');
    const heroPriceNow = root.querySelector('.hm5-hero__price-now');
    const heroPriceWas = root.querySelector('.hm5-hero__price-was s');
    const finalPriceNow = root.querySelector('.hm5-final__now');
    const finalPriceWas = root.querySelector('.hm5-final__was s');

    // Estado actual de opciones seleccionadas
    let selected = variants[0].options.slice(); // primera variante por default

    function formatPrice(cents) {
      // Shopify guarda precio en centavos, COP los muestra sin decimales
      const amount = Math.floor(cents / 100);
      return '$' + amount.toLocaleString('es-CO');
    }

    function findVariant() {
      return variants.find(v => v.options.every((opt, i) => opt === selected[i]));
    }

    function updateUI() {
      const v = findVariant();
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      if (heroPriceNow) heroPriceNow.textContent = formatPrice(v.price);
      if (finalPriceNow) finalPriceNow.textContent = formatPrice(v.price);
      if (v.compare_at_price) {
        if (heroPriceWas) heroPriceWas.textContent = formatPrice(v.compare_at_price);
        if (finalPriceWas) finalPriceWas.textContent = formatPrice(v.compare_at_price);
      }
      // Actualizar global de Releasit para que use la variante correcta
      try {
        window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [{ id: v.id, quantity: 1 }];
      } catch(_) {}
      // Marcar opciones no disponibles
      wrap.querySelectorAll('.hm5-variant-opt').forEach(btn => {
        const oi = parseInt(btn.dataset.optionIndex, 10);
        const val = btn.dataset.optionValue;
        const testSelection = selected.slice();
        testSelection[oi] = val;
        const exists = variants.find(va => va.available && va.options.every((o,i) => o === testSelection[i]));
        btn.classList.toggle('hm5-variant-opt--unavailable', !exists);
      });
    }

    wrap.querySelectorAll('.hm5-variant-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        const oi = parseInt(btn.dataset.optionIndex, 10);
        const val = btn.dataset.optionValue;
        // Desactivar siblings del mismo grupo
        btn.parentElement.querySelectorAll('.hm5-variant-opt--active').forEach(b => b.classList.remove('hm5-variant-opt--active'));
        btn.classList.add('hm5-variant-opt--active');
        selected[oi] = val;
        updateUI();
      });
    });

    // Inicializar UI segun primera variante
    updateUI();
  }

  function init() {
    const root = document.querySelector('.hm5-yacht');
    if (!root) return;

    // Anti-spy first (highest priority)
    initAntiSpy(root);

    // Variant selector (si producto tiene multiples variantes)
    initVariantSelector(root);

    // Releasit integration
    initReleasitIntegration(root);

    /* ───── 0) PRELOADER counter 000→100 + rotating words ───── */
    const preloader = root.querySelector('#hm5-preloader');
    const counter = root.querySelector('#hm5-counter');
    const bar = root.querySelector('#hm5-bar');
    const words = root.querySelectorAll('#hm5-words .hm5-pw');

    if (preloader && counter && bar) {
      let n = 0;
      let wordIdx = 0;
      const duration = 1800; // ms
      const start = performance.now();
      function tick(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        n = Math.floor(progress * 100);
        counter.textContent = String(n).padStart(3, '0');
        bar.style.width = (progress * 100) + '%';

        const wIdx = Math.min(Math.floor(progress * words.length), words.length - 1);
        if (wIdx !== wordIdx) {
          words[wordIdx].classList.remove('active');
          words[wIdx].classList.add('active');
          wordIdx = wIdx;
        }

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          setTimeout(() => preloader.classList.add('hm5-done'), 300);
        }
      }
      requestAnimationFrame(tick);
    }

    /* ───── 1) BlurText word-by-word (Pro AI Deck) ───── */
    root.querySelectorAll('.hm5-blur-text').forEach((el, blockIdx) => {
      const txt = el.dataset.text || el.textContent;
      el.innerHTML = '';
      const baseDelay = 2.2 + blockIdx * 0.4; // start after preloader
      txt.split(' ').forEach((word, i) => {
        const span = document.createElement('span');
        span.className = 'hm5-blur-text__word';
        span.textContent = word;
        span.style.animationDelay = (baseDelay + i * 0.09) + 's';
        el.appendChild(span);
      });
    });

    /* ───── 2) Scoped cursor trail (only inside hero) ───── */
    const cursorZone = root.querySelector('#hm5-cursor-zone');
    const hero = root.querySelector('#hm5-hero');
    const isTouch = window.matchMedia('(hover: none)').matches;

    if (cursorZone && hero && !isTouch) {
      const POOL = 18;
      const dots = [];
      for (let i = 0; i < POOL; i++) {
        const d = document.createElement('div');
        d.className = 'hm5-cursor-dot';
        cursorZone.appendChild(d);
        dots.push({ el: d, x: -100, y: -100 });
      }
      let mx = -100, my = -100, active = false;

      hero.addEventListener('mouseenter', () => { active = true; });
      hero.addEventListener('mouseleave', () => {
        active = false;
        dots.forEach(d => d.el.style.opacity = '0');
      });
      hero.addEventListener('mousemove', (e) => {
        const r = hero.getBoundingClientRect();
        mx = e.clientX - r.left;
        my = e.clientY - r.top;
      }, { passive: true });

      function loop() {
        if (active) {
          let px = mx, py = my;
          dots.forEach((d, i) => {
            const ease = Math.max(0.18 - i * 0.008, 0.04);
            d.x += (px - d.x) * ease;
            d.y += (py - d.y) * ease;
            const scale = 1 - (i / POOL) * 0.7;
            const op = (1 - i / POOL) * 0.7;
            d.el.style.transform = `translate(${d.x}px, ${d.y}px) translate(-50%, -50%) scale(${scale})`;
            d.el.style.opacity = op.toString();
            px = d.x; py = d.y;
          });
        }
        requestAnimationFrame(loop);
      }
      loop();
    }

    /* ───── 3) Stat counter (count-up on viewport enter) ───── */
    const statNums = root.querySelectorAll('.hm5-stat__num');
    if ('IntersectionObserver' in window && statNums.length) {
      const statIO = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const target = parseInt(el.dataset.target || '0', 10);
            const suffix = el.dataset.suffix || '';
            const finalText = el.textContent.trim();
            const duration = 1400;
            const start = performance.now();
            function tick(now) {
              const p = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              const v = Math.floor(eased * target);
              el.textContent = (target >= 1000) ? v.toLocaleString('es-CO') : v + (suffix ? suffix : '');
              if (p < 1) requestAnimationFrame(tick);
              else el.textContent = finalText;
            }
            requestAnimationFrame(tick);
            obs.unobserve(el);
          }
        });
      }, { threshold: 0.4 });
      statNums.forEach(s => statIO.observe(s));
    }

    /* ───── 4) Letter-by-letter pull-quote reveal (Aethera) ───── */
    const pullquote = root.querySelector('[data-letter-reveal]');
    if (pullquote) {
      // If source given (Liquid version), inject letter spans dynamically
      const src = pullquote.dataset.source;
      if (src && !pullquote.querySelector('span')) {
        // Naive parse: convert HTML, wrap each char in span (preserving em tags)
        const wrap = document.createElement('div');
        wrap.innerHTML = src;
        function letterize(node) {
          if (node.nodeType === 3) { // text
            const frag = document.createDocumentFragment();
            [...node.textContent].forEach(ch => {
              const s = document.createElement('span');
              s.innerHTML = ch === ' ' ? '&nbsp;' : ch;
              frag.appendChild(s);
            });
            node.parentNode.replaceChild(frag, node);
          } else if (node.nodeType === 1) { // element
            [...node.childNodes].forEach(letterize);
          }
        }
        [...wrap.childNodes].forEach(letterize);
        pullquote.innerHTML = wrap.innerHTML;
      }
      if ('IntersectionObserver' in window) {
        const lettersIO = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const spans = entry.target.querySelectorAll('span');
              spans.forEach((sp, i) => {
                sp.style.transitionDelay = (i * 0.028) + 's';
              });
              entry.target.classList.add('hm5-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.3 });
        lettersIO.observe(pullquote);
      }
    }

    /* ───── 5) Horizontal scroll-scrub (Urban Jungle) ───── */
    const scrub = root.querySelector('#hm5-scrub');
    const scrubPan = root.querySelector('#hm5-scrub-pan');
    if (scrub && scrubPan) {
      function onScrubScroll() {
        const r = scrub.getBoundingClientRect();
        const vh = window.innerHeight;
        const total = r.height - vh;
        const past = -r.top;
        const progress = Math.max(0, Math.min(past / total, 1));
        // Move panorama -50% (since width is 200%)
        scrubPan.style.transform = `translateX(${-progress * 50}%)`;
      }
      window.addEventListener('scroll', onScrubScroll, { passive: true });
      onScrubScroll();
    }

    /* ───── 6) Slot-machine number flip (Yacht Club) ───── */
    const slots = root.querySelectorAll('.hm5-slot__big[data-slot]');
    if ('IntersectionObserver' in window && slots.length) {
      const slotIO = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const finalVal = el.dataset.slot;
            const suffix = el.dataset.suffix || '';
            const seq = ['00', '47', '12', '99', '38', '61', '23', '08'];
            let i = 0;
            const interval = setInterval(() => {
              el.textContent = seq[i % seq.length] + suffix;
              i++;
              if (i > 8) {
                clearInterval(interval);
                el.textContent = finalVal + suffix;
              }
            }, 70);
            obs.unobserve(el);
          }
        });
      }, { threshold: 0.5 });
      slots.forEach(s => slotIO.observe(s));
    }

    /* ───── 7) Spotlight mouse reveal (Nike Premium) ───── */
    const spotlight = root.querySelector('#hm5-spotlight');
    const revealLayer = root.querySelector('#hm5-reveal-layer');
    if (spotlight && revealLayer && !isTouch) {
      spotlight.addEventListener('mousemove', (e) => {
        const r = spotlight.getBoundingClientRect();
        const mx = ((e.clientX - r.left) / r.width) * 100;
        const my = ((e.clientY - r.top) / r.height) * 100;
        revealLayer.style.setProperty('--mx', mx + '%');
        revealLayer.style.setProperty('--my', my + '%');
      }, { passive: true });
      spotlight.addEventListener('mouseleave', () => {
        revealLayer.style.setProperty('--mx', '50%');
        revealLayer.style.setProperty('--my', '50%');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
